/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Button from '../Button/Button.js';
import '../Button/Button.Skeleton.js';

const DangerButton = props => /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
  kind: "danger"
}));

export { DangerButton as default };
